import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useInitiateDocumentUpload = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IInitiateDocumentUploadRequestData): Promise<Types.IInitiateDocumentUploadResponseData> => {
            const { data } = await send<Types.IInitiateDocumentUploadRequestData, Types.IInitiateDocumentUploadResponseData>({
                ID: 35688,
                description: 'Initiate document upload request',
                responses: [35689, 35690],
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
